// extracted by css-extract-rspack-plugin
export default {"dropbtn":"UjT4VVs1odhzSdCnRkEz","dropdownContent":"FKnCy14iMz9N4Kabj_xu"};